var _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9095_5422)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9095_5422",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9095_5422)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9095_5422",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9095_5422)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9095_5422",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9095_5422)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_9095_5422",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_9095_5422)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z",
    fill: "#CurrentColor"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_9095_5422",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 16,
    height: 16
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4H4V20H20V4Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_9095_5422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3047 20H5.69599C5.32698 20 4.97311 19.8534 4.71219 19.5925C4.45127 19.3316 4.30469 18.9777 4.30469 18.6087V5.39131C4.30469 5.02231 4.45127 4.66843 4.71219 4.4075C4.97311 4.14658 5.32698 4 5.69599 4H18.3047C18.6737 4 19.0276 4.14658 19.2885 4.4075C19.5494 4.66843 19.696 5.02231 19.696 5.39131V18.6087C19.696 18.9777 19.5494 19.3316 19.2885 19.5925C19.0276 19.8534 18.6737 20 18.3047 20ZM18.3047 5.39131H5.69599V18.6087H18.3047V5.39131ZM7.78294 7.47826C7.92053 7.47826 8.05503 7.51906 8.16943 7.5955C8.28383 7.67195 8.37299 7.78059 8.42565 7.9077C8.47829 8.03481 8.49206 8.17468 8.46522 8.30964C8.43839 8.44457 8.37214 8.56853 8.27484 8.66581C8.17756 8.76309 8.05359 8.82935 7.91866 8.8562C7.78371 8.88304 7.64383 8.86926 7.51672 8.8166C7.38961 8.76396 7.28097 8.67479 7.20453 8.56039C7.12808 8.44599 7.08728 8.3115 7.08728 8.17392C7.08728 8.08256 7.10529 7.99211 7.14024 7.9077C7.17521 7.82331 7.22645 7.74661 7.29103 7.68201C7.35564 7.61742 7.43233 7.56617 7.51672 7.53122C7.60113 7.49625 7.69158 7.47826 7.78294 7.47826ZM7.78294 10.9565C7.92053 10.9565 8.05503 10.9973 8.16943 11.0738C8.28383 11.1502 8.37299 11.2588 8.42565 11.386C8.47829 11.5131 8.49206 11.6529 8.46522 11.7879C8.43839 11.9228 8.37214 12.0468 8.27484 12.1441C8.17756 12.2414 8.05359 12.3076 7.91866 12.3345C7.78371 12.3613 7.64383 12.3475 7.51672 12.2949C7.38961 12.2422 7.28097 12.153 7.20453 12.0386C7.12808 11.9242 7.08728 11.7898 7.08728 11.6522C7.08728 11.5608 7.10529 11.4704 7.14024 11.386C7.17521 11.3016 7.22645 11.2249 7.29103 11.1603C7.35564 11.0957 7.43233 11.0444 7.51672 11.0095C7.60113 10.9745 7.69158 10.9565 7.78294 10.9565ZM7.78294 14.4348C7.92053 14.4348 8.05503 14.4756 8.16943 14.552C8.28383 14.6285 8.37299 14.7371 8.42565 14.8642C8.47829 14.9913 8.49206 15.1312 8.46522 15.2662C8.43839 15.4011 8.37214 15.525 8.27484 15.6223C8.17756 15.7196 8.05359 15.7859 7.91866 15.8127C7.78371 15.8396 7.64383 15.8258 7.51672 15.7731C7.38961 15.7205 7.28097 15.6313 7.20453 15.5169C7.12808 15.4025 7.08728 15.268 7.08728 15.1304C7.08728 15.0391 7.10529 14.9486 7.14024 14.8642C7.17521 14.7798 7.22645 14.7031 7.29103 14.6385C7.35564 14.5739 7.43233 14.5227 7.51672 14.4877C7.60113 14.4528 7.69158 14.4348 7.78294 14.4348ZM10.5871 7.47826H16.1962C16.3807 7.47826 16.5576 7.55156 16.6881 7.68201C16.8185 7.81248 16.8918 7.98942 16.8918 8.17392C16.8918 8.35842 16.8185 8.53536 16.6881 8.66581C16.5576 8.79627 16.3807 8.86956 16.1962 8.86956H10.5871C10.4026 8.86956 10.2257 8.79627 10.0952 8.66581C9.96476 8.53536 9.89146 8.35842 9.89146 8.17392C9.89146 7.98942 9.96476 7.81248 10.0952 7.68201C10.2257 7.55156 10.4026 7.47826 10.5871 7.47826ZM10.5871 10.9565H16.1962C16.3807 10.9565 16.5576 11.0298 16.6881 11.1603C16.8185 11.2907 16.8918 11.4677 16.8918 11.6522C16.8918 11.8367 16.8185 12.0136 16.6881 12.1441C16.5576 12.2745 16.3807 12.3478 16.1962 12.3478H10.5871C10.4026 12.3478 10.2257 12.2745 10.0952 12.1441C9.96476 12.0136 9.89146 11.8367 9.89146 11.6522C9.89146 11.4677 9.96476 11.2907 10.0952 11.1603C10.2257 11.0298 10.4026 10.9565 10.5871 10.9565ZM10.5871 14.4348H16.1739C16.3584 14.4348 16.5353 14.5081 16.6658 14.6385C16.7963 14.769 16.8696 14.9459 16.8696 15.1304C16.8696 15.3149 16.7963 15.4919 16.6658 15.6223C16.5353 15.7528 16.3584 15.8261 16.1739 15.8261H10.5871C10.4026 15.8261 10.2257 15.7528 10.0952 15.6223C9.96476 15.4919 9.89146 15.3149 9.89146 15.1304C9.89146 14.9459 9.96476 14.769 10.0952 14.6385C10.2257 14.5081 10.4026 14.4348 10.5871 14.4348Z",
    fill: "white"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9095_5422"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.d9bfb94c821f66c30b4b93d568050d7e.svg";
export { ForwardRef as ReactComponent };